import {Component, computed, signal} from '@angular/core';
import { ZIM } from 'zego-zim-web';
import {NgOptimizedImage} from '@angular/common';
import {UiStatusBarService} from '../../pages/call/services/ui-status-bar.service';
import {CallStoreService} from '../../pages/call/services/call-store.service';

@Component({
  selector: 'app-network-disconnect-notice',
  standalone: true,
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './network-disconnect-notice.component.html',
  styleUrl: './network-disconnect-notice.component.scss'
})
export class NetworkDisconnectNoticeComponent {
  constructor(
    private callUiStatusBarService: UiStatusBarService,
    private callStore: CallStoreService,
  ) {}

  canShowNotice = computed(() => this.callUiStatusBarService.showStatusBar());
  shouldShowNotice = computed(() => !this.callStore.showCallStatusBar());

  networkNotice = computed(() => {
    let state = this.connectionState();
    switch (state) {
      case ZIM.ConnectionState.Connected: {
        return "Đã kết nối";
      }
      case ZIM.ConnectionState.Disconnected: {
        return "Không có kết nối mạng";
      }
      case ZIM.ConnectionState.Connecting: {
        return "Đang kết nối...";
      }
      case ZIM.ConnectionState.Reconnecting: {
        return "Đang kết nối lại...";
      }
    }
  })

  private connectionState = signal(ZIM.ConnectionState.Disconnected);
}
